import roles from "@/roles";
export default [
  {
    icon: "phone",
    title: "Phones",
    roles: [roles.ADMIN, roles.PHONES_ADMIN],
    children: [
      {
        router: true,
        title: "Customer Service Number",
        to: "CustomerService",
        roles: [roles.ADMIN, roles.PHONES_ADMIN]
      },
      {
        icon: "event",
        router: true,
        roles: [roles.ADMIN, roles.PHONES_ADMIN],
        title: "User Events",
        to: "UserEvents"
      }
    ]
  }
];
